import { ReactComponent as DeviceSettingIcon } from "../../assets/icons/device-setting-icon.svg";
import { Link } from "../../components";
import { controlTypes } from "../../constants/voice";
import { getSelectedDeviceData } from "../../redux/voiceControl-slice";
import styles from "./VoiceControlCard.module.scss";
import { useSelector } from "react-redux";

export function VoiceControlCard({ control }) {
  const deviceSelected = useSelector(getSelectedDeviceData);
  return (
    <div className={styles.voiceControlCard}>
      <div className={styles.controlIcon}>
        <img src={controlTypes[control.type]} alt={control.type} />
      </div>
      <div className={styles.controlName}>
        {control.friendly_name || control.name}
      </div>
      <div className={styles.editControlIcon}>
        <Link to={`/voice/${deviceSelected.cloudId}/controls/${control.id}`}>
          <DeviceSettingIcon />
        </Link>
      </div>
    </div>
  );
}
